import React, { useState, useEffect, useContext } from 'react';
import { Box, Paper, Grid, TextField, Button, MenuItem, Typography, Input, FormControlLabel, Switch } from '@mui/material';



import { findAllCategories } from '../../actions/uiActions';
import { CompanyContext } from '../../CompanyProvider';

function FilterSection({ onList, onCreate }) {
  const [category, setCategory] = useState('All');
  const [sku, setSku] = useState('');
  const [itemName, setItemName] = useState('');
  const [categories, setCategories] = useState(['All']);
  const [loading, setLoading] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const companyCode = useContext(CompanyContext);
  useEffect(() => {
    async function loadCategories() {
      setLoading(true);
      try {
        const data = await findAllCategories(companyCode);
        console.log("Fetched categories:", data);
        setCategories([{categoryID:'All',categoryName:"All"}, ...data]);
      } catch (e) {
        setCategories(['All']);
      } finally {
        setLoading(false);
      }
    }
    loadCategories();
  }, []);

  return (
    <Paper sx={{ p: 2, mb: 2, background: '#ffffff', borderRadius: 2, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #e8edf5' }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          <TextField
            select
            label="Category"
            value={category}
            onChange={e => setCategory(e.target.value)}
            fullWidth
            sx={{width: '200px'}}
            size="small"
            disabled={loading}
            InputProps={{ sx: { background: '#f8fafc', borderRadius: 2 } }}
            SelectProps={{ MenuProps: { PaperProps: { sx: { background: '#ffffff' } } } }}
          >
            {categories.map(cat => (
              <MenuItem key={cat.categoryID} value={cat.categoryID} sx={{ color: '#1a3c6e', fontWeight: 500 }}>{cat.categoryName}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="SKU"
            value={sku}
            onChange={e => setSku(e.target.value)}
            fullWidth
            size="small"
            InputProps={{ sx: { background: '#f8fafc', borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Item Name"
            value={itemName}
            onChange={e => setItemName(e.target.value)}
            fullWidth
            size="small"
            InputProps={{ sx: { background: '#f8fafc', borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControlLabel
            control={
              <Switch
                checked={outOfStock}
                onChange={e => setOutOfStock(e.target.checked)}
                color="primary"
              />
            }
            label="Out of Stock Only"
            sx={{ ml: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ height: 40, background: '#1a3c6e', color: '#fff', fontWeight: 700, borderRadius: 2, boxShadow: '0 2px 8px 0 rgba(26,60,110,0.13)' }}
            onClick={() => {
              const filterObject = { category, sku: sku.toLowerCase(), itemName: itemName.toLowerCase(), outOfStock };
              onList(filterObject);
            }}
          >
            List
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}


export default FilterSection;
